// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"7a1b80ae","488":"60b5e639"}[chunkId] + ".chunk.js";
};